export default "__VITE_ASSET__fdc5fc15__"